import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "topic-container-title"
};
var _hoisted_2 = {
  class: "type margin-r16"
};
var _hoisted_3 = {
  class: "id margin-r16"
};
var _hoisted_4 = {
  class: "tags"
};
var _hoisted_5 = {
  key: 0,
  class: "tag margin-r8"
};
var _hoisted_6 = {
  key: 1,
  class: "tag margin-r8"
};
var _hoisted_7 = ["id"];
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  key: 0
};
var _hoisted_10 = {
  class: "time"
};
var _hoisted_11 = {
  class: "topic-content"
};
var _hoisted_12 = {
  class: "options"
};
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = {
  class: "option-code"
};
var _hoisted_15 = ["innerHTML"];
var _hoisted_16 = ["innerHTML"];
var _hoisted_17 = {
  key: 0,
  class: "select"
};
var _hoisted_18 = {
  class: "flex"
};
var _hoisted_19 = ["innerHTML"];
var _hoisted_20 = ["innerHTML"];
var _hoisted_21 = {
  key: 0,
  class: "option-code"
};
var _hoisted_22 = {
  key: 1,
  class: "radio-judge"
};
var _hoisted_23 = ["innerHTML"];
import { ref, toRefs, computed } from 'vue';
import { EXERCISE_CODE_OBJ } from '@/const/excersise';
import { env_name } from '@/util';
import { getStore } from '@/util/store.js';

// 接收每一条习题的数据

export default {
  __name: 'QuestionContent',
  props: {
    question: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    focus: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  emits: ['getRecord', 'focus'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    // 定义子组件的方法
    var getRecord = function getRecord() {
      emit('getRecord', question.value);
    };
    // 已关联的弹框长度计算
    var offsetWidth = computed(function () {
      var offsetWidth = 500;
      if (container.value) {
        // 习题左边的长度 - (已关联标签离左侧的距离 - 时间长度)
        offsetWidth = container.value.offsetWidth - (containerInfo.value.offsetWidth - 140 - 16 * 4);
      }
      return offsetWidth + 'px';
    });
    var _toRefs = toRefs(props),
      question = _toRefs.question;
    // console.log('question', question.value)
    var contentRef = ref();
    var container = ref(null); // 列表内容容器
    var containerInfo = ref(null); // 习题信息容器
    var tooltipActive = ref([]); // 已关联数据
    var focus = ref(undefined); // 点击样式

    var codeType = EXERCISE_CODE_OBJ; //  习题类型
    var content = question.value.exercise.exercise.content;
    // 删除p标签
    question.value.exercise.exercise.content = content ? content : '';
    if (question.value.exercise.exercise.childs) {
      var childs = question.value.exercise.exercise.childs;
      // console.log('childs', childs)
      childs.forEach(function (item) {
        // 删除p标签
        item.content = item.content ? item.content : '';
        if (item.type === 'SINGLE_CHOICE' || item.type === 'MULTIPLE_CHOICE') {
          for (var o = 0; o < item.options.length; o++) {
            var _content = item.options[o].content || '';
            // 删除p标签
            item.options[o].content = _content ? _content : '';
          }
        } else if (item.type === 'JUDGE') {
          for (var _o = 0; _o < item.options.length; _o++) {
            var _content2 = item.options[_o].content;
            // 删除p标签
            item.options[_o].content = _content2 ? _content2 : '';
          }
        }
      });
    }

    /**
     * 关联数据展示
     */
    var linkedData = function linkedData() {
      setTimeout(function () {
        emit('focus', question.value.exercise.uniqueCode);
      }, 50);
      var citeResTypeText = function citeResTypeText(type) {
        return type === 0 ? '课程' : type === 1 ? '学程' : '习练';
      };
      tooltipActive.value = question.value.commonResCites.map(function (_item) {
        return {
          citeResType: _item.citeResType,
          resType: citeResTypeText(_item.citeResType),
          resName: _item.name,
          resId: _item.citeResId,
          id: _item.id,
          practiceId: question.value.resId
        };
      });
    };

    /**
     * 关联的标签跳转
     * @param value
     */
    var jumpView = function jumpView(value) {
      var accessToken = getStore({
        name: 'access_token'
      });
      var commonName2 = env_name ? "//".concat(env_name, "web.zhixuehuijiao.cn") : "//web.zhixuehuijiao.cn";
      window.open("".concat(commonName2, "/inspirationCentre?inspirationCentre=%2Fsub-inspiration-centre-svc%2FeditParper%3FresId%3D").concat(value.resId, "&token=").concat(accessToken));
    };
    return function (_ctx, _cache) {
      var _component_t_popup = _resolveComponent("t-popup");
      var _component_t_tooltip = _resolveComponent("t-tooltip");
      return _openBlock(), _createElementBlock("div", {
        ref_key: "container",
        ref: container,
        class: "topic-container"
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        ref_key: "containerInfo",
        ref: containerInfo,
        class: "topic-container-info"
      }, [_createElementVNode("span", _hoisted_2, _toDisplayString(_unref(codeType)[_unref(question).exercise.exercise.type]), 1), _createElementVNode("span", _hoisted_3, "ID: " + _toDisplayString(_unref(question).exercise.uniqueCode), 1), _createElementVNode("div", _hoisted_4, [_unref(question).creatingStatus === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_5, "已完成")) : _unref(question).creatingStatus === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_6, "创作中")) : _createCommentVNode("", true), _unref(question).commonResCites && _unref(question).commonResCites.length > 0 ? (_openBlock(), _createBlock(_component_t_tooltip, {
        key: 2
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_popup, {
            trigger: "click",
            placement: "right",
            "overlay-style": {
              maxWidth: offsetWidth.value
            },
            hideEmptyPopup: "",
            showArrow: "",
            attach: '#myPopup' + _unref(question).exercise.uniqueCode
          }, {
            content: _withCtx(function () {
              return [_cache[2] || (_cache[2] = _createTextVNode(" 已关联 ", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tooltipActive.value, function (_item, index) {
                return _openBlock(), _createElementBlock("span", {
                  key: index
                }, [_createElementVNode("span", null, _toDisplayString(_item.resType) + "“" + _toDisplayString(_item.resName) + " ID ", 1), _createElementVNode("span", {
                  style: {
                    "color": "#5eb0ff",
                    "cursor": "pointer"
                  },
                  onClick: function onClick($event) {
                    return jumpView(_item);
                  }
                }, _toDisplayString(_item.id), 9, _hoisted_8), _cache[1] || (_cache[1] = _createTextVNode("” ", -1)), index < tooltipActive.value.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "、")) : _createCommentVNode("", true)]);
              }), 128))];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("div", {
                class: "myPopup",
                id: '#myPopup' + _unref(question).exercise.uniqueCode
              }, [_createElementVNode("span", {
                class: "tag margin-r8 relevance",
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return linkedData();
                })
              }, "已关联")], 8, _hoisted_7)];
            }),
            _: 1
          }, 8, ["overlay-style", "attach"])];
        }),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_10, "编辑时间: " + _toDisplayString(_unref(question).updateTime), 1)], 512)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_unref(question).exercise.exercise.type === 'SINGLE_CHOICE' || _unref(question).exercise.exercise.type === 'MULTIPLE_CHOICE' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("p", {
        innerHTML: _unref(question).exercise.exercise.content
      }, null, 8, _hoisted_13), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(question).exercise.exercise.options, function (option, idx) {
        return _openBlock(), _createElementBlock("div", {
          key: idx,
          class: "option"
        }, [_createElementVNode("span", _hoisted_14, _toDisplayString(option.code) + ". ", 1), _createElementVNode("p", {
          innerHTML: option.content,
          class: "option-text"
        }, null, 8, _hoisted_15)]);
      }), 128))], 64)) : _unref(question).exercise.exercise.type === 'JUDGE' || _unref(question).exercise.exercise.type === 'COMPLETION' || _unref(question).exercise.exercise.type === 'ANSWER_QUESTIONS' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("p", {
        innerHTML: _unref(question).exercise.exercise.content
      }, null, 8, _hoisted_16), _unref(question).exercise.exercise.type === 'JUDGE' ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toConsumableArray(_cache[3] || (_cache[3] = [_createElementVNode("div", {
        class: "radio"
      }, null, -1), _createElementVNode("span", {
        class: "margin-r8"
      }, "正确", -1), _createElementVNode("div", {
        class: "radio"
      }, null, -1), _createElementVNode("span", {
        class: "margin-r8"
      }, "错误", -1)])))) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createElementVNode("div", _hoisted_18, [_unref(question).exercise.exercise.content ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        innerHTML: "".concat(_unref(question).exercise.exercise.content)
      }, null, 8, _hoisted_19)) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(question).exercise.exercise.childs, function (item, idx) {
        return _openBlock(), _createElementBlock("div", {
          key: idx,
          class: "grid"
        }, [item.content ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          ref_for: true,
          ref_key: "contentRef",
          ref: contentRef,
          innerHTML: "".concat(item.content.replace(/<p(.*?)>/, "<p$1>(".concat(idx + 1, ")")))
        }, null, 8, _hoisted_20)) : (_openBlock(), _createElementBlock("p", {
          key: 1,
          ref_for: true,
          ref_key: "contentRef",
          ref: contentRef
        }, "(" + _toDisplayString(idx + 1) + ")", 513)), item.options ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["grid gap", {
            flex: item.type === 'JUDGE'
          }])
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, function (option, index) {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["option", {
              select: item.type === 'JUDGE'
            }])
          }, [item.type === 'SINGLE_CHOICE' || item.type === 'MULTIPLE_CHOICE' ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(option.code) + ". ", 1)) : _createCommentVNode("", true), item.type === 'JUDGE' ? (_openBlock(), _createElementBlock("div", _hoisted_22)) : _createCommentVNode("", true), _createElementVNode("p", {
            innerHTML: option.content
          }, null, 8, _hoisted_23)], 2);
        }), 128))], 2)) : _createCommentVNode("", true)]);
      }), 128))], 64))])])], 512);
    };
  }
};